<script setup lang="ts">
// TODO провести рефакторинг
import './style.scss';

import type { UiIconProps } from './types';
import sprite from './ui-icons.svg';

const className = 'ui-icon';

defineProps<UiIconProps>();
</script>

<template>
  <svg
    :key="name"
    :class="[className, svgClass]"
  >
    <use :href="`${sprite}#${name}`" />
  </svg>
</template>
